import { render } from "./BusinessView.vue?vue&type=template&id=3f84d61e"
import script from "./BusinessView.vue?vue&type=script&lang=js"
export * from "./BusinessView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__